<template>
  <label :for="`tender-tax-exempt-${planType}-${index}`">{{
    t('sites.singleSite.financialConfig.mealPlans.form.tenders.taxExempt')
  }}</label>
  <SelectButtonField
    :id="`tender-tax-exempt-${planType}-${index}`"
    :name="fieldName"
    :options="taxExemptOptions"
    optionLabel="label"
    optionValue="value"
    :unselectable="false"
    :disabled="isDisabled"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useMealPlan } from '../../meal-plan/composables';

// Define props
defineProps({
  fieldName: {
    type: String,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  planType: {
    type: String,
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
});

// Set localization
const { t } = useI18n();

// Set meal plan composable
const { taxExemptOptions } = useMealPlan();
</script>
